import { createFileRoute } from '@tanstack/react-router'
import { CompanyEnrichmentLite } from '@/features/admin/company-enrichment-lite'

export const Route = createFileRoute(
  '/_authenticated/admin/company-enrichment-lite'
)({
  component: CompanyEnrichmentLite,
})
